import { FormatSettings, IColumns } from './ParameterInterface';

export const setParametres = (
  propKey: string,
  datasetId: string,
  name: string,
  parameterId: string,
) => {
  return {
    type: 'SET_PARAMETERS',
    payload: {
      propKey,
      datasetId,
      name,
      parameterId,
    },
  };
};

export const addParameter = (propKey: string, formatType?: any) => {
  return {
    type: 'ADD_PARAMETER',
    payload: {
      propKey,
      formatType,
    },
  };
};

export const previewParameter = (
  propKey: string,
  preview: boolean,
  name: string,
  columns: any,
  isRange: string,
  values?: Array<string | number>,
  minValue?: number | string,
  maxValue?: number | string,
  stepValue?: number | string,
  loadFromColumn?: boolean,
  loadDefaultValue?: boolean,
  formatOptions?: FormatSettings,
) => {
  return {
    type: 'PREVIEW_PARAMETER',
    payload: {
      propKey,
      preview,
      name,
      columns,
      isRange,
      values,
      minValue,
      maxValue,
      stepValue,
      loadFromColumn,
      loadDefaultValue,
      formatOptions,
    },
  };
};

export const syncParameterData = (
  parameterId: string,
  values: any,
  minValue: number,
  maxValue: number,
  stepValue: number,
  defaultValue?: string,
) => {
  return {
    type: 'SYNC_PARAMETER_DATA',
    payload: {
      parameterId,
      values,
      minValue,
      maxValue,
      stepValue,
      defaultValue,
    },
  };
};

export const setParameterData = (parameterId: string, userSelection: any) => {
  return {
    type: 'UPDATE_PARAMETER_USER_SELECTION',
    payload: {
      parameterId,
      userSelection,
    },
  };
};

export const loadSavedParameter = (propKey: string, parameterId: string) => {
  return {
    type: 'LOAD_SAVED_PARAMETER',
    payload: {
      propKey,
      parameterId,
    },
  };
};

export const updateParameter = (propKey: string, parameterId: string) => {
  return {
    type: 'UPDATE_PARAMETER',
    payload: {
      propKey,
      parameterId,
    },
  };
};

export const deleteParameter = (propKey: string, parameterId: string) => {
  return {
    type: 'DELETE_PARAMETER',
    payload: {
      propKey,
      parameterId,
    },
  };
};

export const addParameterToChart = (propKey: string, parameterId: string) => {
  return {
    type: 'ADD_REMOVE_PARAMETER_TO_CHART',
    payload: {
      propKey,
      parameterId,
    },
  };
};

export const resetParameterSession = (propKey: string) => {
  return {
    type: 'RESET_PARAMETER_SESSION',
    payload: {
      propKey,
    },
  };
};

export const loadAllParameters = (parameters: any) => {
  return {
    type: 'LOAD_ALL_PARAMETERS',
    payload: {
      parameters,
    },
  };
};

export const setParameterIntoFilters = (
  propKey: string,
  parameterId: string,
  uId: string,
  itemIndex: number,
  currentChartAxesName: string,
) => {
  return {
    type: 'SET_PARAMETER_INTO_FILTERS',
    payload: {
      propKey,
      parameterId,
      uId,
      itemIndex,
      currentChartAxesName,
    },
  };
};

export const deleteFilterFromParameter = (
  propKey: string,
  uId: string,
  currentChartAxesName: string,
) => {
  return {
    type: 'DELETE_FILTER_PARAMETER_FROM',
    payload: {
      propKey,
      uId,
      currentChartAxesName,
    },
  };
};

// PARAMETER INTO CALCULATIONS

export const setCalculationId = (calculationId: string, parameterId: string) => {
  return {
    type: 'SET_CALCULATION_ID',
    payload: {
      calculationId,
      parameterId,
    },
  };
};

export const removeCalculationId = (calculationId: string, parameterId: string) => {
  return {
    type: 'REMOVE_CALCULATION_ID',
    payload: {
      calculationId,
      parameterId,
    },
  };
};

// export const hasCalculation = (has_calculation: boolean, propKey: string) => {
//   return {
//     type: 'HAS_CALCULATION',
//     payload: {
//       has_calculation,
//       propKey,
//     },
//   };
// };

export const resetParameterState = () => {
  return { type: 'CLEAR_PARAMETER_SESSION' };
};
